import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, TextField, Typography } from "@mui/material";
import useGlobal from "./useGlobal";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";





export function LoginDialog({open}) {
    const [axios,setAxios] = useGlobal('axios')
    const [jwt,setJWT] = useGlobal('jwt')
    const [permissions,setPermissions] = useGlobal('permissions',[])
    const [budget,setBudget] = useGlobal('budget',-1)
    const [gname,setGname] = useGlobal('gname');
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [mistry,setMistry] = useState(0)
    const [remindme,setRemindme] = useState(false)
    const [waitingstuff,setWaitingstuff] = useGlobal('waitingstuff',false)
    const [globalinfo,setGlobalinfo] = useGlobal('globalinfo',false)
    const [wrongcred,setWrongcred] = useState(false)
    const currentlocation = useLocation()



    // useEffect(() => {
    //     console.log('Logindialog'.axios,open)
    //     if (open) {
    //       axios.post('login',{'username':'Dohmen, Christoph','password':'Behindert$1',}).then(resp =>{
    //         if (resp.status == 200){
    //           console.log('set jwt')
    //         setJWT(resp.data.jwt)
    //         setPermissions(resp.data.permissions)}
    //         setBudget(resp.data.budget)
    //         setGname(resp.data.username)
    //       }
    //     )
    //     }
    // },[axios,open])


    useEffect(() => {
        setGname(username)
    },[username])
         
    const handleEnter = (e) => {
        if (e.key === 'Enter') {handleLogin()}
    }

    const handleLogin = () => {
      setMistry(mistry+1)
      axios.post('login',{'username':username,'password':password,}).then(resp =>{
          console.log('p',resp)
          if (resp.status == 200){
            console.log('set jwt')
          setJWT(resp.data.jwt)
          setGname(resp.data.username)
          setPermissions(resp.data.permissions)
          setBudget(resp.data.budget)
          setWaitingstuff(resp.data.waitingstuff)
          setGlobalinfo(resp.data.balkeninfo)
          setWrongcred(false)
          } else {
            setWrongcred(resp.response.data.msg)
          }
        }
      ).catch(resp => {
        console.log('e',resp)
        setWrongcred(resp.response.data.msg)
      })
    }

    return (
      <>
        <Dialog open={open} PaperProps={{style:{padding:'0', borderRadius:'16px', overflow:'hidden'},className:'userinfodialog'}} sx={{backdropFilter:'blur(10px)'}}>
            <DialogTitle sx={{background:'linear-gradient(135deg, #25346a, #3a5a9c)', color:'white', padding:'24px 28px', textAlign:'center'}}>
              <Typography variant="h5" sx={{fontWeight:700}}>RDHS-Shop</Typography>
            </DialogTitle>
            <DialogContent sx={{padding:'28px 28px 16px !important', display:'flex', flexDirection:'column', gap:'16px'}}>
              <TextField fullWidth label="Benutzername" value={username} onChange={e => setUsername(e.target.value)}/>
              <TextField fullWidth label="Passwort" value={password} type='password'
                    onChange={e => setPassword(e.target.value)} onKeyPress={e => handleEnter(e)}/>
              <Typography variant="caption" sx={{color:'#999'}}>Aldente-Login</Typography>
            </DialogContent>
        {!!wrongcred && <Alert severity="warning" sx={{margin:'0 16px'}}>{wrongcred}</Alert> }
            <DialogActions sx={{padding:'8px 28px 24px'}}>
                <Button fullWidth variant="contained" color="secondary" size="large" sx={{borderRadius:'8px', fontWeight:600}} onClick={(event) => handleLogin()}>Anmelden</Button>
            </DialogActions>
        </Dialog>

      </>
    )
}